import Link from 'next/link';
import { PopupActions, PopupContent } from '@/components/PagePopup/PopupContent';
import { Button } from '@music-vine/cadence/ui';
import { Text } from '@music-vine/cadence/ui';
import { GenericCouponPopupCopy } from '@/constants/popups';
import { getUniversalCookie } from '@/cookies';
import type { PagePopupProps, PopUpPosition, PopUpVariant } from '@/components/PagePopup/PagePopup';
export const getCouponPopupProps = ({
  logPopupClick,
  asPath,
  coupon
}: {
  logPopupClick: (type: string, popup_id: string, nextPath: string) => void;
  asPath: string;
  coupon: ReturnType<typeof getUniversalCookie>;
}): PagePopupProps | null => {
  const utmSourceCookie = getUniversalCookie('utm_source');
  const isVidconCoupon = !!(coupon && utmSourceCookie === 'vidcon');
  const popupId = isVidconCoupon ? `vidcon-coupon-popup-${coupon}` : `stripe-coupon-popup-${coupon}`;
  const termsUrl = isVidconCoupon ? 'https://uppbeat.ac-page.com/vidcon2025-terms' : '';
  const termsLink = <>
      <Link className="underline hover:underline" href={termsUrl} onClick={() => {
      logPopupClick('view-terms', popupId, termsUrl);
    }} target="_blank">
        Terms & Conditions
      </Link>{' '}
      apply.
    </>;
  let couponPopupSubtitle = GenericCouponPopupCopy.subtitle;
  if (isVidconCoupon) {
    couponPopupSubtitle = '50% DISCOUNT UNLOCKED';
  }
  let couponPopupDescription: {
    desktop: React.ReactNode;
    mobile: React.ReactNode;
  } = {
    desktop: GenericCouponPopupCopy.description,
    mobile: 'Your discount will be applied at checkout.'
  };
  if (isVidconCoupon) {
    couponPopupDescription = {
      desktop: <>
          Sweet! Get 50% off any plan, monthly or annual, for 12 months. Your
          discount will be applied at checkout. {termsLink}
        </>,
      mobile: <div className="mt-1 flex flex-col gap-0.5 text-center">
          <div>Your discount will be applied at checkout.</div>
          <div>{termsLink}</div>
        </div>
    };
  }
  return {
    storageKey: popupId,
    storageType: 'sessionStorage',
    variant: 'default' as PopUpVariant,
    position: 'bottom-right' as PopUpPosition,
    excludeSlugs: ['/pricing', '/my/account', '/music/latest-releases'],
    delay: 500,
    children: <PopupContent mainTitle={GenericCouponPopupCopy.mainTitle} subtitle={couponPopupSubtitle} variant="default">
        <Text className="font-sans text-sm">
          {couponPopupDescription.desktop}
        </Text>
        <PopupActions>
          <Button asChild className="mt-1 w-full" variant="brand">
            <Link href={GenericCouponPopupCopy.href} onClick={() => {
            window.postMessage({
              type: 'DISMISS_POPUP'
            }, '*');
            logPopupClick('cta', popupId, GenericCouponPopupCopy.href);
          }}>
              {GenericCouponPopupCopy.cta}
            </Link>
          </Button>
        </PopupActions>
      </PopupContent>,
    onClickDismiss: () => {
      logPopupClick('dismiss', popupId, asPath);
    },
    noXIcon: {
      desktop: false,
      mobile: false
    },
    mobileChildren: <PopupContent className="p-2.5">
        <div className="flex flex-col gap-1">
          <div className="text-center font-heading text-gray-950 text-lg dark:text-white">
            {`${GenericCouponPopupCopy.mainTitle}`!}
          </div>
          <Text className="text-center font-sans text-sm">
            {couponPopupDescription.mobile}
          </Text>
          <div className="mt-4 flex flex-row gap-2 md:mt-2">
            <Button border className="w-full" fontSize="sm" onClick={() => {
            window.postMessage({
              type: 'DISMISS_POPUP'
            }, '*');
          }} size="lg" variant="subtle">
              Dismiss
            </Button>
            <Button asChild className="w-full" fontSize="sm" size="lg" variant="brand">
              <Link href={GenericCouponPopupCopy.href} onClick={() => {
              window.postMessage({
                type: 'DISMISS_POPUP'
              }, '*');
              logPopupClick('cta', popupId, GenericCouponPopupCopy.href);
            }}>
                {GenericCouponPopupCopy.cta}
              </Link>
            </Button>
          </div>
        </div>
      </PopupContent>
  };
};